<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
          <el-form-item label="所属广告平台" prop="advertPlatform">
          <el-input v-model="dataForm.advertPlatform" placeholder="所属广告平台"></el-input>
      </el-form-item>
          <el-form-item label="广告主账号" prop="advertiserId">
          <el-input v-model="dataForm.advertiserId" placeholder="广告主账号"></el-input>
      </el-form-item>
          <el-form-item label="日期" prop="date">
          <el-input v-model="dataForm.date" placeholder="日期"></el-input>
      </el-form-item>
          <el-form-item label="日终结余(单位元)" prop="balance">
          <el-input v-model="dataForm.balance" placeholder="日终结余(单位元)"></el-input>
      </el-form-item>
          <el-form-item label="现金支出(单位元)" prop="cashCost">
          <el-input v-model="dataForm.cashCost" placeholder="现金支出(单位元)"></el-input>
      </el-form-item>
          <el-form-item label="总支出(单位元)" prop="cost">
          <el-input v-model="dataForm.cost" placeholder="总支出(单位元)"></el-input>
      </el-form-item>
          <el-form-item label="冻结(单位元)" prop="frozen">
          <el-input v-model="dataForm.frozen" placeholder="冻结(单位元)"></el-input>
      </el-form-item>
          <el-form-item label="总存入(单位元)" prop="income">
          <el-input v-model="dataForm.income" placeholder="总存入(单位元)"></el-input>
      </el-form-item>
          <el-form-item label="赠款支出(单位元)" prop="rewardCost">
          <el-input v-model="dataForm.rewardCost" placeholder="赠款支出(单位元)"></el-input>
      </el-form-item>
          <el-form-item label="共享钱包支出(单位元)" prop="sharedWalletCost">
          <el-input v-model="dataForm.sharedWalletCost" placeholder="共享钱包支出(单位元)"></el-input>
      </el-form-item>
          <el-form-item label="总转入(单位元)" prop="transferIn">
          <el-input v-model="dataForm.transferIn" placeholder="总转入(单位元)"></el-input>
      </el-form-item>
          <el-form-item label="总转出(单位元)" prop="transferOut">
          <el-input v-model="dataForm.transferOut" placeholder="总转出(单位元)"></el-input>
      </el-form-item>
          <el-form-item label="状态（开1、关0）" prop="status">
          <el-input v-model="dataForm.status" placeholder="状态（开1、关0）"></el-input>
      </el-form-item>
          <el-form-item label="创建人" prop="createdBy">
          <el-input v-model="dataForm.createdBy" placeholder="创建人"></el-input>
      </el-form-item>
          <el-form-item label="修改人" prop="updatedBy">
          <el-input v-model="dataForm.updatedBy" placeholder="修改人"></el-input>
      </el-form-item>
          <el-form-item label="创建时间" prop="createTime">
          <el-input v-model="dataForm.createTime" placeholder="创建时间"></el-input>
      </el-form-item>
          <el-form-item label="修改时间" prop="updateTime">
          <el-input v-model="dataForm.updateTime" placeholder="修改时间"></el-input>
      </el-form-item>
          <el-form-item label="删除时间" prop="deleteTime">
          <el-input v-model="dataForm.deleteTime" placeholder="删除时间"></el-input>
      </el-form-item>
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        advertPlatform: '',
        advertiserId: '',
        date: '',
        balance: '',
        cashCost: '',
        cost: '',
        frozen: '',
        income: '',
        rewardCost: '',
        sharedWalletCost: '',
        transferIn: '',
        transferOut: '',
        status: '',
        createdBy: '',
        updatedBy: '',
        createTime: '',
        updateTime: '',
        deleteTime: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        advertPlatform: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        advertiserId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        date: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        balance: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        cashCost: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        cost: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        frozen: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        income: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        rewardCost: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        sharedWalletCost: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        transferIn: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        transferOut: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        createdBy: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updatedBy: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        createTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        deleteTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/rdaccountdailystat/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/rdaccountdailystat/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
